/**
 * Funciones helper para la pantalla de Rutas Pendientes de Revisión (NS)
 */

/**
 * Formatear fecha (solo día) para display en formato chileno
 * @param {string} dateString - Fecha en formato ISO (YYYY-MM-DD)
 * @returns {string} Fecha formateada (ej: "07-07-2026")
 */
export const formatFecha = (dateString) => {
  if (!dateString) return '-';

  try {
    // Mediodía para evitar problemas de corrimiento de zona horaria con fechas 'YYYY-MM-DD'
    const date = new Date(`${dateString}`.slice(0, 10) + 'T12:00:00');

    return date.toLocaleDateString('es-CL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'America/Santiago'
    });
  } catch (error) {
    return dateString;
  }
};

/**
 * Formatear fecha-hora completa (ej. revisado_fecha) para display en formato chileno
 * @param {string} dateTimeString - Fecha-hora en formato ISO
 * @returns {string} Fecha y hora formateada (ej: "07-07-2026 09:15")
 */
export const formatFechaHora = (dateTimeString) => {
  if (!dateTimeString) return '-';

  try {
    const date = new Date(dateTimeString);
    if (Number.isNaN(date.getTime())) return dateTimeString;

    return date.toLocaleString('es-CL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'America/Santiago'
    });
  } catch (error) {
    return dateTimeString;
  }
};
